/// <reference types="@next/third-parties/google" />

export const getGtmId = (locale?: string) => {
  return locale === 'vi'
    ? process.env.NEXT_PUBLIC_VN_GTM
    : process.env.NEXT_PUBLIC_GTM;
};

class GTMHelper {
  static customEvent = (event: string, params = {}) =>
    window.dataLayer?.push({
      event,
      ...params,
    });

  static customCategory = (eventCategory: string, params = {}) =>
    window.dataLayer?.push({
      eventCategory,
      ...params,
    });

  static customRcHomeCategory = (rcHomeEventCategory: string, params = {}) =>
    window.dataLayer?.push({
      rcHomeEventCategory,
      ...params,
    });

  static clickRcHomeCategory = (rcHomeEventCategory: string, params = {}) =>
    window.dataLayer?.push({
      event: 'gtm.click',
      rcHomeEventCategory,
      ...params,
    });
}

export default GTMHelper;
